module.exports = __webpack_public_path__ + "static/media/P2_not_word.484a2cd9.png";